export const TABLE_TENNIS = 2;
export const BEACH_VOLLEYBALL = 3;
export const VOLLEYBALL = 4;
export const BOX = 5;
export const TENNIS = 6;
export const FOOTBALL = 7;
export const WATER_POLLO = 8;
export const RUGBY = 9;
export const BASEBALL = 10;
export const AMERICAN_FOOTBAL = 11;
export const HOCKEY = 12;
export const LOTTERY = 13;
export const FORMULA1 = 14;
export const SWIMMING = 15;
export const ELECTIONS = 16;
export const ATHLETICS = 17;
export const BEACH_FOOTBALL = 18;
export const HANDBALL = 19;
export const BIATHLON = 20;
export const SKIING = 21;
export const SPECIAL_OFFERS = 22;
export const KVN = 23;
export const POKER = 24;
export const DARTS = 25;
export const CYCLING = 26;
export const WEATHER = 27;
export const WHAT_WHERE_WHEN = 28;
export const SNOOKER = 29;
export const ICE_HOCKEY = 30;
export const BASKETBALL = 31;
export const BADMINTON = 32;
export const OLYMPIC = 33;
export const FUTSAL = 34;
export const BANDY = 35;
export const FLOORBALL = 36;
export const CULTURE = 37;
export const CYBER_SPORTS = 38;
export const MARTIAL_ARTS = 39;
export const CHESS = 40;
export const BASKTBALL_NCAA = 41;
export const CYBER_SPORTS_DOTA2 = 42;



// WEBPACK FOOTER //
// ./js/constants/SportType.js